
export class BolsaMultiConfigAjusteProdParmDTO {
  uf: string;
  municipio: string;
  diasAjusteProducao: number;
  diasSemanaEntrega: string[];
}